











































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const gpeData: any = require('@/data/gpe_data.json');

const TRANSPORT_MODES = [
  { key: 'metro', label: 'Métro', icon: 'fa-subway', color: '#003D9B', shadow: 'rgba(0,61,155,0.4)',  regex: /m[eé]tro/i },
  { key: 'rer',   label: 'RER',   icon: 'fa-train',  color: '#7843A4', shadow: 'rgba(120,67,164,0.4)', regex: /\brer\b|\btrain\b/i },
  { key: 'tram',  label: 'Tram',  icon: 'fa-train',  color: '#E95C0A', shadow: 'rgba(233,92,10,0.4)', regex: /tram/i     },
];

const API_URL =
  'https://data.iledefrance-mobilites.fr/api/explore/v2.1/catalog/datasets/projets_lignes_idf/exports/geojson';

@Component
export default class FutureTransportsPopup extends Vue {
  @Prop({ default: false }) visible!: boolean;

  TRANSPORT_MODES = TRANSPORT_MODES;

  isVisible: boolean = false;
  loading: boolean = false;
  error: string | null = null;
  resultCount: number | null = null;

  selectedRegions = { idf: true };

  selectedModes: { [key: string]: boolean } = {
    metro: true,
    rer:   false,
    tram:  false,
  };

  cachedGeojson: any = null;

  @Watch('visible')
  onVisibleChange(val: boolean) {
    this.isVisible = val;
  }

  @Watch('isVisible')
  onIsVisibleChange(val: boolean) {
    this.$emit('update:visible', val);
    // Only prefetch API data if RER or Tram are toggled on
    if (val && !this.cachedGeojson && (this.selectedModes.rer || this.selectedModes.tram)) {
      this.prefetchData();
    }
  }

  async prefetchData() {
    try {
      const response = await axios.get(API_URL);
      this.cachedGeojson = response.data;
    } catch (err) {
      console.error('[FutureTransports] Prefetch failed:', err);
    }
  }

  async loadFutureTransports() {
    this.loading = true;
    this.error = null;
    this.resultCount = null;

    try {
      const allFeatures: any[] = [];

      // ── Métro: local GPE data, NO API call ──────────────────────
      if (this.selectedModes.metro) {
        const data = gpeData as any;

        // Build color map for popup rendering
        const lineColorMap: Record<string, string> = {};
        for (const line of data.transport) {
          lineColorMap[line.line] = line.color;
        }

        // Convert each GPE line's geometry to a GeoJSON Feature
        for (const line of data.transport) {
          if (line.route_geometry) {
            allFeatures.push({
              type: 'Feature',
              properties: {
                nom_projet: line.line,
                color: line.color,
                number: line.number,
                source: 'gpe',
              },
              geometry: line.route_geometry,
            });
          }
        }

        // Deduplicate gares across lines (a station can appear in multiple lines)
        const seenNames = new Set<string>();
        const allGares: any[] = [];
        for (const line of data.transport) {
          for (const g of line.gares) {
            if (!seenNames.has(g.name)) {
              seenNames.add(g.name);
              allGares.push({ ...g, primaryColor: line.color });
            }
          }
        }

        this.$emit('gpeStationsLoaded', { gares: allGares, lineColorMap });
      } else {
        this.$emit('gpeStationsLoaded', { gares: [], lineColorMap: {} });
      }

      // ── RER + Tram: API (metro deliberately excluded) ────────────
      const apiModes = TRANSPORT_MODES.filter(m => m.key !== 'metro' && this.selectedModes[m.key]);
      if (apiModes.length > 0) {
        const geojson = this.cachedGeojson || (await axios.get(API_URL)).data;
        if (!this.cachedGeojson) this.cachedGeojson = geojson;

        const activeRegexes = apiModes.map(m => m.regex);
        const apiFeatures = (geojson.features || []).filter((f: any) => {
          const nomProjet: string = (f.properties && f.properties.nom_projet) || '';
          return activeRegexes.some((rx: RegExp) => rx.test(nomProjet));
        });
        allFeatures.push(...apiFeatures);
      }

      this.resultCount = allFeatures.length;
      this.$emit('linesLoaded', { type: 'FeatureCollection', features: allFeatures });
      this.isVisible = false;
    } catch (err) {
      this.error = 'Impossible de charger les données. Veuillez réessayer plus tard.';
      console.error('Future transports error:', err);
    } finally {
      this.loading = false;
    }
  }

  clearResults() {
    this.resultCount = null;
    this.error = null;
    this.$emit('gpeStationsLoaded', { gares: [], lineColorMap: {} });
    this.$emit('linesCleared');
    this.isVisible = false;
  }
}
